import { render, staticRenderFns } from "./DatabaseRepair.vue?vue&type=template&id=4770d748"
import script from "./DatabaseRepair.vue?vue&type=script&lang=js"
export * from "./DatabaseRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports